export interface ISwapDonorCluster {
    positionInSwap: number,
    clusterId: number,
    clusterNumber: number,
    chainId: number
}